// Cloakla theme JS — minimal interactions
(function(){
  // Smooth scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({behavior:'smooth'}); }
      }
    });
  });

  // Floating tag persistent dismiss (session only)
  try {
    if (sessionStorage.getItem('cloakla_tag_closed')) {
      const f = document.getElementById('floatingTag');
      if (f) f.style.display = 'none';
    }
    document.querySelectorAll('.floating-tag .close').forEach(c => {
      c.addEventListener('click', () => sessionStorage.setItem('cloakla_tag_closed','1'));
    });
  } catch(e){}
})();
